import { render } from "./AppointmentDetailView.vue?vue&type=template&id=4bbf3725&scoped=true"
import script from "./AppointmentDetailView.vue?vue&type=script&lang=js"
export * from "./AppointmentDetailView.vue?vue&type=script&lang=js"

import "./AppointmentDetailView.vue?vue&type=style&index=0&id=4bbf3725&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bbf3725"]])

export default __exports__